<style lang="stylus" scoped>
    .header-close
        justify-content flex-end
    .edit-fst
        display block
        cursor pointer
        height 71px

        .fst-file
            display none

        .fst-img
            position absolute
            width 40px
            height 40px
            margin 15px 240px

    .edit-scd
        padding 30px 12px

        .scd-common
            display flex
            align-content center

            .title-length
                width 100px

        .scd-avatar
            padding-bottom 5px
            border-bottom 1px solid #EEE
            .avatar-word
                display flex
                align-items center
                color #606266

            .avatar-img
                border-radius 50%
                width 47px
                height 47px

            .avatar-file
                display none

            .avatar-click
                cursor pointer
                color #037fff
                position absolute
                right 14px
                height 47px
                line-height 47px
                z-index 700

        .scd-nick
            height 65px
            border-bottom 1px solid #EEE

            .nick-word
                display flex
                align-items center
                color #606266

            .nick-input
                border 0px
                outline 0
                width 300px

        .scd-profile
            .profile-word
                display flex
                align-items center
                color #606266

            .profile-input
                width 377px
                padding 5px
                margin-top 10px
    .pc-des
        position relative
        display inline-block
        width 320px
        padding-top 20px
</style>
<template>
    <div class="mask" v-if="ishow">
        <Dialog class="per-edit">
            <div class="header-close">
                <iconSymbol :name="'Del'" @click.native="cancel" />
            </div>
            <div class="edit-scd">
                <div class="scd-avatar scd-common">
                    <span class="avatar-word title-length">{{ $t("userAvatar") }}:</span>
                    <label class="avatar-click">
                        <input
                            ref="avafile"
                            accept=".jpg,.jpeg,.png,.gif"
                            type="file"
                            :title="'点击更换头像'"
                            class="avatar-file"
                            @change="getFileData($event, 1)"
                        />
                        {{ $t("modifyAvatar") }}
                    </label>
                    <img
                        class="avatar-img"
                        :src="
                            (avatar ? `${avatar}?change=${Math.random()}` : null) ||
                            'https://edrawcloudpubliccn.oss-cn-shenzhen.aliyuncs.com/profile/avatar.jpg'
                        "
                    />
                </div>
                <div class="scd-nick scd-common">
                    <span class="nick-word title-length">{{ $t("nickname") }}:</span>
                    <input v-model="visiter.nickName" class="nick-input" type="text" minlength="1" maxlength="20" />
                </div>
                <div class="scd-profile scd-common">
                    <span class="profile-word title-length">{{ $t("personalSignature") }}:</span>
                    <div class="pc-des">
                        <Input v-model="visiter.profile" :rows="6" size="small" type="textarea" :maxlength="200"></Input>
                    </div>
                </div>
            </div>
            <div class="edit-confirm">
                <Button type="error" size="small" @click="cancel">{{ $t("cancel") }}</Button>
                <Button type="primary" size="small" @click="save">{{ $t("save") }}</Button>
            </div>
        </Dialog>
    </div>
</template>
<script>
    import "./style/editUserInfoDialog.styl";
    export default {
        data() {
            return {
                // 是否保存成功
                isdong: false,
                visiter: {
                    nickName: "",
                    profile: "",
                },
            };
        },
        computed: {
            intervieweeUserInfo() {
                return this.$store.state.userPage.intervieweeUserInfo;
            },
            avatar() {
                console.log(this.intervieweeUserInfo);
                return this.intervieweeUserInfo.avatar;
            },
            ishow: {
                get() {
                    return this.$store.state.userPage.iShowEdit;
                },
                set() {
                    this.$store.commit("userPage/setState", { type: "iShowEdit", data: false });
                },
            },
            ishowPictrue: {
                get() {
                    return this.$store.state.userPage.isPicture;
                },
            },
            userInfo() {
                return this.$store.state.userInfo;
            },
        },
        watch: {
            ishow(val) {
                if (!val) return;
                this.visiter = {
                    nickName: this.intervieweeUserInfo.nick_name,
                    profile: this.intervieweeUserInfo.profile,
                };
            },
        },
        methods: {
            //如果是author电话的话，将电话号码后6位隐藏
            //如果是邮箱的话，隐藏邮箱后缀
            getSafeName(name) {
                if (!name) return "";
                if (name.match(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)) {
                    name = name.substr(0, name.indexOf("@"));
                }
                if (name.match(/^1[3456789]\d{9}$/)) {
                    name = name
                        .split("")
                        .map((v, idx) => {
                            if (idx > 2 && idx < 7) {
                                return "*";
                            } else {
                                return v;
                            }
                        })
                        .join("");
                }
                return name;
            },

            cancel() {
                this.$store.commit("userPage/controlBoxShow", { type: "iShowEdit", isShow: false });
                Object.assign(this.$data, this.$options.data());
            },
            save() {
                if (this.isdong) return;
                let params = {};
                if (this.visiter.nickName.toLowerCase().includes("edraw")) {
                    this.$edMessage.error("昵称不能包括edraw字符");
                    return;
                }
                this.isdong = true;
                if (this.visiter.nickName) {
                    params = Object.assign(params, { name: this.visiter.nickName });
                }
                params = Object.assign(params, { profile: this.visiter.profile });

                this.$edApi
                    .EditUserInfor(
                        {
                            id: this.userInfo.user_id,
                            token: this.userInfo.token,
                        },
                        params,
                        this.userInfo
                    )
                    .then((res) => {
                        this.isdong = false;
                        this.$edMessage.success("保存成功！");
                        this.$store.commit("userPage/setUserInfo", {
                            nick_name: res.data.nick_name,
                            profile: res.data.profile,
                        });
                        this.$store.commit("userPage/setIntervieweeUserInfo", {
                            nick_name: res.data.nick_name,
                            profile: res.data.profile,
                        });
                        this.cancel();
                    });
            },
            getFileData(e, type) {
                let fr = new FileReader(),
                    file = e.target.files[0],
                    _self = this;
                fr.onload = function () {
                    _self.$store.commit("userPage/getPitcture", fr.result);
                    _self.$store.commit("userPage/controlBoxShow", { type: "isPicture", isShow: true });
                    _self.$store.commit("userPage/changePictureType", type);
                    _self.$refs.avafile.value = null;
                    // _self.$refs.bgfile.value = null;
                };
                fr.readAsDataURL(file);
            },
        },
        mounted() {
            const _this = this;
            window.addEventListener("keyup", function (e) {
                if (e.code == "Escape" && !_this.ishowPictrue) {
                    _this.cancel();
                }
            });
        },
        beforeDestroy() {
            window.removeEventListener("keyup", function (e) {
                if (e.code == "Escape" && !_this.ishowPictrue) {
                    _this.cancel();
                }
            });
        },
    };
</script>

<i18n>
{
  "zh": {
    "userAvatar": "用户头像",
    "nickname": "昵称",
    "personalSignature": "个性签名",
    "modifyAvatar": "修改头像",
    "save": "保存",
    "cancel": "取消"
  },
  "en": {
    "userAvatar": "Profile Picture",
    "nickname": "Nick Name",
    "personalSignature": "Write a description about yourself.",
    "modifyAvatar": "Modify Avatar",
    "save": "Save",
    "cancel": "Cancel"
  },
  "fr": {
    "userAvatar": "Photo de profil",
    "nickname": "Ajouter un pseudo",
    "personalSignature": "Ajouter une bio",
    "modifyAvatar": "Modifier la photo de profil",
    "save": "Enregistrer",
    "cancel": "Annuler"
  },
  "de": {
    "userAvatar": "Avatar",
    "nickname": "Spitzname",
    "personalSignature": "Unterschrift",
    "modifyAvatar": "Avatar ändern",
    "save": "speichern",
    "cancel": "Abbrechen"
  },
  "jp": {
    "userAvatar": "アバター",
    "nickname": "ニックネーム",
    "personalSignature": "紹介",
    "modifyAvatar": "アバターを変更",
    "save": "保存",
    "cancel": "キャンセル"
  },
  "es": {
    "userAvatar": "Foto de perfil",
    "nickname": "Apodo",
    "personalSignature": "Firma",
    "modifyAvatar": "Modificar avatar",
    "save": "Guardar",
    "cancel": "Cancelar"
  },
  "pt": {
    "userAvatar": "Foto do perfil",
    "nickname": "Apelido",
    "personalSignature": "Slogan do perfil",
    "modifyAvatar": "Modificar foto do perfil",
    "save": "Salvar",
    "cancel": "Cancelar"
  },
  "it": {
    "userAvatar": "Immagine del profilo",
    "nickname": "Soprannome",
    "personalSignature": "Slogan personale",
    "modifyAvatar": "Slogan personale",
    "save": "Salva",
    "cancel": "Annulla"
  },
  "tw": {
    "userAvatar": "用戶頭像",
    "nickname": "暱稱",
    "personalSignature": "個性簽名",
    "modifyAvatar": "修改頭像",
    "save": "保存",
    "cancel": "取消"
  },
  "kr": {
    "userAvatar": "프로필 사진",
    "nickname": "닉네임",
    "personalSignature": "현재 기분",
    "modifyAvatar": "프로필 사진 수정",
    "save": "저장",
    "cancel": "취소"
  },
  "id": {
    "userAvatar": "Gambar Profil",
    "nickname": "Nama Panggilan",
    "personalSignature": "Tulis deskripsi tentang diri Anda.",
    "modifyAvatar": "Ubah Avatar",
    "save": "Simpan",
    "cancel": "Batalkan"
  }
}
</i18n>
